import { render } from "./Information_Request.vue?vue&type=template&id=66b31a44"
import script from "./Information_Request.vue?vue&type=script&lang=js"
export * from "./Information_Request.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__